var Code, GeneralInformationDocShape, additionalResourceShape, arrayOf, boolean, calculated, convertToDraftJS, convertToShape, docShape, documentId, extendedCheck, extendedParse, extraChecks, guidelineTagType, initial, mapOf, mediator, number, numberChecks, object, oneOf, optional, percentType, shape, string, switchableTextType, _ref, _ref1, _ref2;

Code = require('/lib/db_docs/field_types/code_type');

docShape = require('lib/db_docs/field_types/doc_shape');

shape = require('lib/db_docs/field_types/shape');

arrayOf = require('lib/db_docs/field_types/array_of');

documentId = require('lib/db_docs/field_types/document_id');

oneOf = require('lib/db_docs/field_types/one_of');

mapOf = require('lib/db_docs/field_types/map_of');

_ref = require('lib/db_docs/field_types/built_in_types'), boolean = _ref.boolean, string = _ref.string, number = _ref.number, extraChecks = _ref.extraChecks, object = _ref.object;

_ref1 = require('lib/db_docs/field_types/type_decorators'), initial = _ref1.initial, extendedParse = _ref1.extendedParse, calculated = _ref1.calculated, extendedCheck = _ref1.extendedCheck;

numberChecks = extraChecks.number;

mediator = require('mediator');

_ref2 = require('lib/db_docs/field_types/shape').typeDecorators, optional = _ref2.optional, calculated = _ref2.calculated;

percentType = optional(extendedCheck(numberChecks.min(0))(number));

convertToDraftJS = require('lib/draft_utils').convertToDraftJS;

guidelineTagType = shape({
  id: documentId,
  value: initial('')(string),
  codes: optional(initial({})(mapOf(Code))),
  selected: optional(boolean)
});

additionalResourceShape = shape({
  id: documentId,
  text: initial('')(string),
  link: initial('')(string),
  description: initial('')(string)
});

convertToShape = function(content) {
  if (_.isString(content)) {
    return {
      showTextInput: true,
      text: convertToDraftJS(content)
    };
  } else {
    return _.extend({}, content, {
      text: convertToDraftJS(content.text || '')
    });
  }
};

switchableTextType = shape({
  showTextInput: optional(boolean),
  text: optional(extendedParse(convertToDraftJS)(object))
});

GeneralInformationDocShape = docShape({
  applicability: optional(percentType),
  authors: optional(string),
  byName: optional(string),
  category: optional(initial([])(arrayOf(string))),
  clarityOfPresentation: optional(percentType),
  collectionId: optional(number),
  consumerEngagement: optional(extendedParse(convertToShape)(switchableTextType)),
  contactAddress: optional(string),
  contactEmail: optional(string),
  contactName: optional(string),
  contactTelephone: optional(string),
  contactWeb: optional(string),
  country: initial([])(arrayOf(string)),
  countryFlag: optional(string),
  declarationOfInterest: optional(boolean),
  declarationOfInterestChronicPain: optional(extendedParse(convertToShape)(switchableTextType)),
  declarationOfInterestManaged: optional(extendedParse(convertToShape)(switchableTextType)),
  department: optional(string),
  describedAsLiving: optional(boolean),
  describedAsRapid: optional(boolean),
  description: optional(extendedParse(convertToDraftJS)(object)),
  disclaimer: optional(extendedParse(convertToDraftJS)(object)),
  doi: initial('')(string),
  editorialIndependence: optional(percentType),
  editorialProcess: percentType,
  equityConsiderations: optional(object),
  field: initial([])(arrayOf(string)),
  focus: optional(initial([])(arrayOf(string))),
  fullReference: initial('')(string),
  fundingBody: optional(initial('')(string)),
  generalDescription: optional(extendedParse(convertToDraftJS)(object)),
  gradebookChapter: optional(string),
  gradingEvidenceMethod: optional(string),
  guidelineGroupDetails: optional(extendedParse(convertToShape)(switchableTextType)),
  guidelineInterventions: optional(arrayOf(guidelineTagType)),
  guidelineLanguage: optional(initial('')(string)),
  guidelineNoId: optional(string),
  guidelinePopulations: optional(arrayOf(guidelineTagType)),
  guidelineUpdatePlans: optional(extendedParse(convertToShape)(switchableTextType)),
  includeNonEnglishDatabases: optional(oneOf([true, false, 'notReported'])),
  institutionLogoUrl: optional(string),
  institutionName: optional(string),
  institutionShortName: optional(string),
  intent: optional(initial('')(string)),
  isbn: initial('')(string),
  issn: optional(string),
  keywords: optional(string),
  language: optional(string),
  latestLiteratureSearchDate: optional(string),
  linksAndVideos: optional(initial([])(arrayOf(additionalResourceShape))),
  oldGradebookLink: optional(string),
  organizationType: initial([])(arrayOf(string)),
  owner: optional(string),
  peopleWithLivedExperience: optional(switchableTextType),
  plus: optional(initial([])(arrayOf(string))),
  pmid: initial('')(string),
  progress: optional(initial([])(arrayOf(string))),
  progressPlus: optional(initial('')(string)),
  publicationDate: initial('')(string),
  publishLastSearchDate: optional(string),
  researchPriorities: optional(initial('')(string)),
  rigorOfDevelopment: percentType,
  scopeAndPurpose: percentType,
  scorePassed: optional(boolean),
  secondWorldRegionCategory: optional(initial([])(arrayOf(string))),
  shortTitle: optional(string),
  slug: optional(string),
  socialCapital: optional(initial([])(arrayOf(string))),
  source: initial('')(string),
  sourceDocumentLink: initial('')(string),
  stakeholderInvolvement: optional(percentType),
  subIntent: optional(initial('')(string)),
  targetAudience: optional(initial('')(string)),
  targetPopulation: optional(initial('')(string)),
  topic: optional(string),
  title: initial('')(string),
  users: optional(initial([])(arrayOf(string))),
  version: optional(string),
  versionMajor: optional(string),
  versionMinor: optional(string),
  whoIrisId: optional(string),
  worldRegion: initial([])(arrayOf(string))
});

module.exports = GeneralInformationDocShape;
